import { render } from "./budgetrevenues-modal.vue?vue&type=template&id=b09f130e"
import script from "./budgetrevenues-modal.vue?vue&type=script&lang=js"
export * from "./budgetrevenues-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__